export const isCheck2Admin = (userRole, userPermissions) => {
  // console.log("userRole:", userRole);
  // console.log("userPermissions:", userPermissions);
  // console.log("is admin:", 
  //   userRole === "Staff" &&
  //   Array.isArray(userPermissions) &&
  //   userPermissions.includes("Check ² Admin")
  // );
  return (
    userRole === "Staff" &&
    Array.isArray(userPermissions) &&
    userPermissions.includes("Check ² Admin")
  );
};

/**
 * Admins can always download.
 * Non-admins are blocked if RCA is present (and you can extend with other rules).
 */
export const canDownloadAmlReport = ({
  userRole,
  userPermissions,
  rcaPresent,
  pepBlocked = false,
  // add more flags later if needed
}) => {
  if (isCheck2Admin(userRole, userPermissions)) return true;
  if (rcaPresent) return false;
  if (pepBlocked) return false;
  return true;
};
